import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Box, Button, ButtonGroup, LinearProgress } from "@mui/material";
import I18n from "i18n-js";
import { Link } from "react-router-dom";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Autocomplete, DateRangePicker, PageHeader } from "../../common";
import useAnalytics from "./useAnalytics";

export interface AnalyticsProps {
  showHeader?: boolean;
}

export default function Analytics({ showHeader = true }: AnalyticsProps) {
  const {
    loading,
    granularity,
    dateRange,
    activeTab,
    dataOptions,
    waiverIds,
    locationIds,
    getChartData,
    handleGranularityChange,
    handleWaiversChange,
    handleLocationChange,
    handleDateRangeChange,
  } = useAnalytics();
  console.log({ activeTab });
  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<ShowChartIcon />}
          title={I18n.t("Analytics.title")}
        />
      )}
      <ButtonGroup variant="outlined" sx={{ mb: 3 }}>
        <Button
          component={Link}
          to="/submits/analytics/waivers"
          variant={activeTab === "waivers" ? "contained" : "outlined"}
          color="primary"
        >
          {I18n.t("Analytics.waivers")}
        </Button>
        <Button
          component={Link}
          to="/submits/analytics/participants"
          variant={activeTab === "participants" ? "contained" : "outlined"}
          color="primary"
        >
          {I18n.t("Analytics.participants")}
        </Button>
      </ButtonGroup>
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <DateRangePicker value={dateRange} onChange={handleDateRangeChange} />
        <Autocomplete
          options={dataOptions?.granularity?.data || undefined}
          value={granularity}
          onChange={handleGranularityChange}
          style={{ width: "140px" }}
          label={I18n.t("Analytics.granularity")}
        />
        <Autocomplete
          options={dataOptions?.waiver_ids?.data || undefined}
          value={waiverIds}
          onChange={handleWaiversChange}
          style={{ width: "300px" }}
          multiple
          label={I18n.t("Analytics.waivers")}
        />
        <Autocomplete
          options={dataOptions?.location_ids?.data || undefined}
          value={locationIds}
          onChange={handleLocationChange}
          style={{ width: "300px" }}
          multiple
          label={I18n.t("Analytics.locations")}
        />
      </Box>

      <Box>
        <LinearProgress
          style={{ visibility: loading ? "visible" : "hidden" }}
        />
      </Box>

      {!loading && (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={getChartData()}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#8884d8"
              name={
                activeTab === "waivers"
                  ? I18n.t("Analytics.waivers")
                  : I18n.t("Analytics.participants")
              }
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </>
  );
}
